// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1pf3q","label":"Section_label__1O6Up","contentWrap":"Section_contentWrap__fAqaJ","footer":"Section_footer__384g7","footerInner":"Section_footerInner__3FEIG"};